import React from 'react'
import { A } from 'hookrouter'
import { useStyles } from './Link.styles'

export interface ILinkProps {
  children: JSX.Element | JSX.Element[] | string
  route?: string
  url?: string
  openTab?: boolean
  footer?: boolean
  isUnderline?: boolean
  onClick?: () => void
}

export const Link = ({
  children,
  route,
  url,
  openTab = false,
  footer = false,
  isUnderline = false,
  onClick
}: ILinkProps) => {
  const classes = useStyles()
  const target = openTab ? '_blank' : '_self'
  let styles = classes.link

  if (footer) {
    styles = classes.linkFooter
  } else if (isUnderline) {
    styles = classes.linkText
  }

  if (route) {
    return (
      <A href={route} className={classes.link} onClick={onClick}>
        {children}
      </A>
    )
  }

  return (
    <a href={url} target={target} className={styles} onClick={onClick}>
      {children}
    </a>
  )
}
